import Dispatcher from "../../../Dispatcher";
import LoginApi from "./LoginApi";
import { Login } from "../records/Login";

class LoginDataManager
{
    public async login(username: string, pwd: string): Promise<any>
    {
        try
        {
            const response = await LoginApi.getToken(username, pwd);

            Dispatcher.dispatch({
                type: "login/loaded",
                token: response.token
            });
        }
        catch (error)
        {
            Dispatcher.dispatch({
                type: "login/error",
                error
            });
        }
    }

    public async revokeToken(username: string, pwd: string): Promise<any>
    {
        try
        {
            const revokeResponse = await LoginApi.revokeToken(username, pwd);
            const getTokenResponse = await LoginApi.getToken(username, pwd);

            Dispatcher.dispatch({
                type: "login/revoke-token/fulfilled",
                token: getTokenResponse.token
            });
        }
        catch (error)
        {
            Dispatcher.dispatch({
                type: "login/revoke-token/error",
                error
            });
        }
    }

    public async changePassword(newPassword: string): Promise<any>
    {
        try
        {
            const changePasswordResponse = await LoginApi.changePassword(newPassword);

            Dispatcher.dispatch({
                type: "login/change-password/fulfilled"
            });
        }
        catch (error)
        {
            Dispatcher.dispatch({
                type: "login/change-password/error",
                error
            });
        }
    }
}

export default new LoginDataManager();
